import { FC } from 'react';

import { IconProps } from '.';

export const CloseIcon: FC<IconProps> = ({
  width = 10,
  height = 10,
  color = '#172B4D',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5312 0.52827C0.791549 0.26792 1.21366 0.26792 1.47401 0.52827L5.0026 4.05687L8.5312 0.52827C8.79155 0.26792 9.21366 0.26792 9.47401 0.52827C9.73436 0.788619 9.73436 1.21073 9.47401 1.47108L5.94541 4.99967L9.47401 8.52827C9.73436 8.78862 9.73436 9.21073 9.47401 9.47108C9.21366 9.73143 8.79155 9.73143 8.5312 9.47108L5.0026 5.94248L1.47401 9.47108C1.21366 9.73143 0.791549 9.73143 0.5312 9.47108C0.27085 9.21073 0.27085 8.78862 0.5312 8.52827L4.05979 4.99967L0.5312 1.47108C0.27085 1.21073 0.27085 0.788619 0.5312 0.52827Z"
      fill={color}
    />
  </svg>
);
